"use client";

import { unit } from '@ant-design/cssinjs';
const getRTLStyle = _ref => {
  let {
    componentCls,
    menuArrowOffset,
    calc
  } = _ref;
  return {
    ["".concat(componentCls, "-rtl")]: {
      direction: 'rtl'
    },
    ["".concat(componentCls, "-submenu-rtl")]: {
      transformOrigin: '100% 0'
    },
    // Vertical Arrow
    ["".concat(componentCls, "-rtl").concat(componentCls, "-vertical,\n    ").concat(componentCls, "-submenu-rtl ").concat(componentCls, "-vertical")]: {
      ["".concat(componentCls, "-submenu-arrow")]: {
        '&::before': {
          transform: "rotate(-45deg) translateY(".concat(unit(calc(menuArrowOffset).mul(-1).equal()), ")")
        },
        '&::after': {
          transform: "rotate(45deg) translateY(".concat(unit(menuArrowOffset), ")")
        }
      }
    }
  };
};
export default getRTLStyle;